var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "view-button" },
                on: { click: _vm.toggleView }
              },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: _vm.viewMode === "table" ? "th-large" : "list"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "view-button",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.viewMode === "table" ? "Канбан" : "Таблица") +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value:
                      _vm.viewMode === "table"
                        ? "sidebar-fields"
                        : "sidebar-kanban",
                    expression:
                      "viewMode === 'table' ? 'sidebar-fields' : 'sidebar-kanban'"
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" },
                on: { click: _vm.onPopoverClose }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            ),
            _vm._v(" "),
            _vm.canEditRecruitTasks()
              ? _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.showModal(null, false)
                      }
                    }
                  },
                  [
                    _vm.isBusy
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        Новая заявка\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          !_vm.isIntegrated
            ? _c(
                "div",
                { staticClass: "page-filters" },
                [
                  _c(
                    "filters-drawer",
                    {
                      attrs: {
                        "hide-search": true,
                        "is-busy": _vm.isBusy,
                        "filter-tags": _vm.activeFilterTags
                      },
                      on: {
                        "remove-tag": _vm.removeFilterTag,
                        submit: _vm.onSearch,
                        clear: _vm.onClearFilters
                      }
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Вакансии")
                          ]),
                          _vm._v(" "),
                          _c("vacancy-multi-select", {
                            ref: "vacancy_multi_select",
                            attrs: { id: "vacancy-multi-select" },
                            on: { onSelect: _vm.onSelectVacancy }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Дата открытия")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-start-opened-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.start_opened_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "start_opened_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.start_opened_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "auto" }
                                },
                                [_c("span", [_vm._v("—")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-end-opened-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.end_opened_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "end_opened_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.end_opened_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Дата закрытия")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-start-closed-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.start_closed_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "start_closed_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.start_closed_date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "auto" }
                                },
                                [_c("span", [_vm._v("—")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-end-closed-date",
                                      size: "sm",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.filters.end_closed_date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "end_closed_date",
                                          $$v
                                        )
                                      },
                                      expression: "filters.end_closed_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Объекты")
                          ]),
                          _vm._v(" "),
                          _c("location-multi-select", {
                            ref: "location_multi_select",
                            attrs: { id: "location-multi-select" },
                            on: { onSelect: _vm.onSelectLocation }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Участники")
                          ]),
                          _vm._v(" "),
                          _c("user-multi-select", {
                            ref: "user_multi_select",
                            attrs: {
                              id: "user-multi-select",
                              title: "Участники"
                            },
                            on: { onSelect: _vm.onSelectUser }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Ответственные")
                          ]),
                          _vm._v(" "),
                          _c("user-multi-select", {
                            ref: "user_multi_select_assigned",
                            attrs: {
                              id: "user-multi-select-assigned",
                              title: "Ответственные"
                            },
                            on: { onSelect: _vm.onSelectUserAssigned }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "small text-muted" },
                                    [_vm._v("Статус")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "input-statuses",
                                      size: "sm",
                                      options: _vm.statusOptions
                                    },
                                    model: {
                                      value: _vm.filters.status_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "status_id", $$v)
                                      },
                                      expression: "filters.status_id"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "small text-muted" },
                                    [_vm._v("Срочно")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        id: "input-urgency",
                                        size: "sm"
                                      },
                                      model: {
                                        value: _vm.filters.urgency,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filters, "urgency", $$v)
                                        },
                                        expression: "filters.urgency"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("Все заявки")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: true } },
                                        [_vm._v("Да")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: false } },
                                        [_vm._v("Нет")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "small text-muted" }, [
                            _vm._v("Теги")
                          ]),
                          _vm._v(" "),
                          _c("recruit-tag-multi-select", {
                            ref: "tag_multi_select",
                            attrs: { id: "tag-multi-select" },
                            on: { onSelect: _vm.onSelectTag }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  {
                    staticClass: "page-table-container",
                    class: { "border-0": _vm.viewMode === "kanban" }
                  },
                  [
                    _vm.viewMode === "table"
                      ? _c("b-table", {
                          ref: "recruit_tasks",
                          staticClass: "custom-table mb-0 text-small",
                          attrs: {
                            id: "recruit-tasks",
                            "select-mode": "multi",
                            "tbody-tr-class": _vm.tbodyRowClass,
                            "sticky-header": "",
                            responsive: "",
                            busy: _vm.isBusy,
                            items: _vm.items,
                            fields: _vm.renderedFields,
                            "no-provider-filtering": "",
                            "no-provider-paging": "",
                            "no-provider-sorting": "",
                            "no-local-sorting": ""
                          },
                          on: {
                            "update:busy": function($event) {
                              _vm.isBusy = $event
                            },
                            "sort-changed": _vm.sortChanged,
                            "row-clicked": _vm.rowClicked,
                            "row-dblclicked": _vm.onRowDblClicked
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "table-busy",
                                fn: function() {
                                  return [
                                    _c("tables-skeleton", {
                                      attrs: {
                                        fields: _vm.renderedFields,
                                        rows: 5
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "head(selected)",
                                fn: function(row) {
                                  return [
                                    _c("b-form-checkbox", {
                                      staticClass: "mx-1",
                                      attrs: {
                                        indeterminate: _vm.indeterminate,
                                        disabled: _vm.allSelectDisabled,
                                        size: "md"
                                      },
                                      on: { change: _vm.selectAllRows },
                                      model: {
                                        value: _vm.allSelected,
                                        callback: function($$v) {
                                          _vm.allSelected = $$v
                                        },
                                        expression: "allSelected"
                                      }
                                    })
                                  ]
                                }
                              },
                              {
                                key: "cell(selected)",
                                fn: function(row) {
                                  return [
                                    _c("b-form-checkbox", {
                                      staticClass: "mx-1",
                                      attrs: {
                                        size: "md",
                                        checked: row.item.selected
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.onRowDblClicked(row.item)
                                        }
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    })
                                  ]
                                }
                              },
                              {
                                key: "cell(assigned)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getAssignedName(row.item.assigned)
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(status_id)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          row.item.status_name ||
                                            _vm.getStatusText(
                                              row.item.status_id
                                            )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(opened_date)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatTableDate(
                                            row.item.opened_date
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(closed_date)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatTableDate(
                                            row.item.closed_date
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(urgency)",
                                fn: function(row) {
                                  return [
                                    row.item.urgency
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "custom-tag tag-danger"
                                          },
                                          [_vm._v("Да")]
                                        )
                                      : _c("span", [_vm._v("Нет")])
                                  ]
                                }
                              },
                              {
                                key: "cell(tags)",
                                fn: function(row) {
                                  return [
                                    row.value
                                      ? _c(
                                          "div",
                                          _vm._l(row.value, function(tag) {
                                            return _c(
                                              "span",
                                              {
                                                key: tag.id,
                                                staticClass:
                                                  "custom-tag mr-1 mb-1",
                                                style: _vm.getBadgeStyle(
                                                  tag.color
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(tag.name) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(action)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass: "custom-dropdown",
                                        attrs: {
                                          variant: "link",
                                          "toggle-class":
                                            "text-decoration-none box-shadow-none",
                                          "no-caret": ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function() {
                                                return [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name:
                                                        "buttons/ellipsis_vertical",
                                                      size: 15
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: { variant: "success" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showModal(
                                                  row.item.id,
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/eye",
                                                size: 14
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Смотреть\n              "
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.canEditRecruitTasks()
                                          ? _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showModal(
                                                      row.item.id,
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "buttons/edit",
                                                    size: 14
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                Редактировать\n              "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canEditRecruitJobPostings()
                                          ? _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: { variant: "info" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleJobPosting(
                                                      row.item.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "navbar/job_postings",
                                                    size: 14
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                Создать объявление\n              "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canEditRecruitTasks()
                                          ? _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: { variant: "danger" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.onRemove(row)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "buttons/trash",
                                                    size: 14
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                Удалить\n              "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3864708461
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.viewMode === "kanban"
                      ? _c("kanban", {
                          attrs: {
                            items: _vm.items,
                            columns: _vm.activeKanbanColumns,
                            "column-value": "status_id",
                            "group-name": "recruit-tasks"
                          },
                          on: { "status-updated": _vm.kanbanUpdateStatus },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "card",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "kb-card shadow-sm",
                                        class: item.urgency
                                          ? "border-danger"
                                          : "border-default",
                                        attrs: { "no-body": "" },
                                        on: {
                                          dblclick: function($event) {
                                            return _vm.onRowDblClicked(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center w-100"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-weight-bold text-truncate mr-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      item.location_vacancy_name
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown",
                                              {
                                                staticClass:
                                                  "custom-dropdown p-0 m-0 custom-btn-secondary",
                                                staticStyle: {
                                                  width: "16px !important"
                                                },
                                                attrs: {
                                                  variant: "link",
                                                  "toggle-class":
                                                    "text-decoration-none box-shadow-none flex-shrink-0",
                                                  "no-caret": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "button-content",
                                                      fn: function() {
                                                        return [
                                                          _c("v-icon", {
                                                            attrs: {
                                                              name:
                                                                "buttons/ellipsis_vertical",
                                                              size: 13
                                                            }
                                                          })
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showModal(
                                                          item.id,
                                                          true
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        name: "buttons/eye",
                                                        size: 14
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                    Смотреть\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.canEditRecruitTasks()
                                                  ? _c(
                                                      "b-dropdown-item",
                                                      {
                                                        attrs: {
                                                          variant: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.showModal(
                                                              item.id,
                                                              false
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            name:
                                                              "buttons/edit",
                                                            size: 14
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                    Редактировать\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.canEditRecruitJobPostings()
                                                  ? _c(
                                                      "b-dropdown-item",
                                                      {
                                                        attrs: {
                                                          variant: "info"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.handleJobPosting(
                                                              item.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            name:
                                                              "navbar/job_postings",
                                                            size: 14
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                    Создать объявление\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.canEditRecruitTasks()
                                                  ? _c(
                                                      "b-dropdown-item",
                                                      {
                                                        attrs: {
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              { item: item }
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            name:
                                                              "buttons/trash",
                                                            size: 14
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                    Удалить\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.location_name
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center w-100 small text-truncate"
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass:
                                                    "mr-2 flex-shrink-0",
                                                  attrs: {
                                                    name: "navbar/locations",
                                                    size: 13
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-truncate"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.location_name)
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center w-100 small"
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2 flex-shrink-0",
                                              attrs: {
                                                name: "buttons/calendar",
                                                size: 13
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatTableDate(
                                                    item.opened_date
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "mx-1" },
                                              [_vm._v("–")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatTableDate(
                                                    item.closed_date
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.tags && item.tags.length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-wrap align-items-center w-100"
                                              },
                                              _vm._l(item.tags, function(tag) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: tag.id,
                                                    staticClass:
                                                      "custom-tag mr-1 mb-1",
                                                    style: _vm.getBadgeStyle(
                                                      tag.color
                                                    )
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(tag.name) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "w-100 m-0 border-light"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center w-100 small text-muted"
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "p-0 pl-1 mr-2 text-decoration-none",
                                                staticStyle: {
                                                  color: "#1A9167 !important"
                                                },
                                                attrs: { variant: "link" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onRowDblClicked(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Открыть\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "text-truncate" },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "mr-1",
                                                  attrs: { icon: "user" }
                                                }),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getAssignedName(
                                                        item.assigned
                                                      ) || "Не назначен"
                                                    ) +
                                                    "\n                "
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1494489839
                          )
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer-update",
                            fn: function() {
                              return [
                                _vm.selected.length > 0
                                  ? _c("span", { staticClass: "mr-2" }, [
                                      _vm._v("\n              Выбрано: "),
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.selected.length))
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selected.length > 0
                                  ? _c("span", {
                                      staticClass: "text-small vertical-divider"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "text-small text-muted mr-2" },
                                  [
                                    _vm._v("Записей: "),
                                    _c("b", [_vm._v(_vm._s(_vm.totalRows))])
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "footer-list",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  [
                                    _vm.selected.length > 0
                                      ? _c(
                                          "b-button",
                                          {
                                            ref: "update_status_button",
                                            staticClass:
                                              "custom-btn-tag text-small",
                                            style: {
                                              "--btn-color": "#85A5FF",
                                              "--btn-text": "#262626"
                                            },
                                            attrs: {
                                              id: "update-status-button"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.popoverShow = !_vm.popoverShow
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-1",
                                              attrs: {
                                                name: "buttons/swap",
                                                size: 10
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Изменить статус\n              "
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4134028916
                      )
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Нет созданных заявок на подбор.")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Создайте новую заявку прямо сейчас")]),
                  _vm._v(" "),
                  _vm.canEditRecruitTasks()
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "custom-btn-primary mt-1",
                          attrs: { disabled: _vm.isBusy },
                          on: {
                            click: function($event) {
                              return _vm.showModal(null, false)
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "buttons/plus", size: 12 }
                          }),
                          _vm._v("\n        Новая заявка\n      ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _vm.selected.length > 0
        ? _c(
            "b-popover",
            {
              ref: "popover_recruitTasks",
              attrs: {
                target: "update-status-button",
                triggers: "click",
                show: _vm.popoverShow,
                placement: "auto",
                container: "my-container"
              },
              on: {
                "update:show": function($event) {
                  _vm.popoverShow = $event
                },
                shown: _vm.onShown,
                hidden: _vm.onHidden
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center w-100"
                          },
                          [
                            _c(
                              "small",
                              { staticClass: "font-weight-bold text-muted" },
                              [_vm._v("Назначить статус")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "close pb-1",
                                attrs: { "aria-label": "Close" },
                                on: { click: _vm.onPopoverClose }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "aria-hidden": "true" } },
                                  [_vm._v("×")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1590724775
              )
            },
            [
              _vm._v(" "),
              _c("b-form-select", {
                ref: "allTasksStatusSelect",
                staticClass: "mb-2",
                attrs: { size: "sm", options: _vm.statusOptions },
                model: {
                  value: _vm.selectedNewStatus,
                  callback: function($$v) {
                    _vm.selectedNewStatus = $$v
                  },
                  expression: "selectedNewStatus"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.onPopoverClose }
                    },
                    [_vm._v("Закрыть")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: !_vm.selectedNewStatus || _vm.isBusy
                      },
                      on: { click: _vm.onPopoverOk }
                    },
                    [_vm._v("Назначить")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "recruit_tasks_table_cols",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.kanbanColumns.length || _vm.viewMode === "kanban"
        ? _c("dynamic-tables", {
            attrs: {
              "storage-key": "recruit_tasks_kanban_cols",
              "sidebar-fields": "sidebar-kanban",
              "fields-model": _vm.kanbanColumns,
              "field-key": "key",
              "allow-delete": ""
            },
            on: {
              "update:fieldsModel": function($event) {
                _vm.kanbanColumns = $event
              },
              "delete-col": _vm.handleDeleteKanbanColumn,
              "sidebar-closed": function($event) {
                _vm.isAddingColumn = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "list-append",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "position-relative" },
                        [
                          !_vm.isAddingColumn
                            ? _c(
                                "b-button",
                                {
                                  staticClass:
                                    "text-decoration-none d-flex align-items-center justify-content-center w-100",
                                  staticStyle: { color: "#1A9167 !important" },
                                  attrs: { variant: "link" },
                                  on: {
                                    click: function($event) {
                                      _vm.isAddingColumn = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "buttons/plus", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-small" }, [
                                    _vm._v("Добавить новую колонку")
                                  ])
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("recruit-task-status-select", {
                                    attrs: {
                                      "exclude-ids": _vm.activeColumnIds
                                    },
                                    on: { onSelect: _vm.handleAddKanbanColumn }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _vm.isAddingColumn
                            ? _c("div", {
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.isAddingColumn = false
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3351589807
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("recruit-task", {
        ref: "recruit_task",
        attrs: {
          "location-id": _vm.locationId,
          "location-name": _vm.locationName,
          "is-integrated": _vm.isIntegrated
        },
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8910a04a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8910a04a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitTasks.vue
// module id = null
// module chunks = 